
export function D(value: any) {
	// return value;
	return '';
}
